import React from 'react';
import { ResultsCountWrapper } from './ResultsCount.styles';

interface ResultsCountProps {
  totalCount: number;
}

const ResultsCount: React.FC<ResultsCountProps> = ({ totalCount }) => {
  return (
    <ResultsCountWrapper>
      <h4>{totalCount}</h4> Results
    </ResultsCountWrapper>
  );
};

export default ResultsCount;
